module.exports = __webpack_public_path__ + "static/media/driver_license_notupdated.dad64874.svg";